import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MenyProduct } from '../models/meny-product.model';
import { environment } from '@environment';
import { FormListItemDTO } from '@sb-tools/typescript/models/dto/form-list-item.dto';
import { ClientForm } from '../models/client-form.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';

@Injectable({
    providedIn: 'root',
})
export class FormService {
    activeSentimentValue = '';
    isHiddenCategoriesAllowed = false;
    isSubmitted = false;
    selectedCategoryRootParentId?: number = null; // parent id (with level=0) of selected category

    constructor(private httpClient: HttpClient) {}

    getAll(): Observable<FormListItemDTO[]> {
        return this.httpClient.get<FormListItemDTO[]>(
            environment.apiInboxUrl + 'admin/formNamesWithUrls?type=' + FormType.webInternal,
        );
    }

    get(name = '', language: LocalizationLanguage = null): Observable<ClientForm> {
        return this.httpClient.get<ClientForm>(environment.apiFormUrl + 'instances', { params: { name, language } });
    }

    getWidgetAuth(): Observable<ClientForm> {
        return this.httpClient.get<ClientForm>(environment.apiFormUrl + 'instances/auth');
    }

    getById(formId: number, language: LocalizationLanguage = null): Observable<ClientForm> {
        return this.httpClient.get<ClientForm>(environment.apiFormUrl + 'instances/' + formId, {
            params: { language },
        });
    }

    getForwardForm(): Observable<ClientForm> {
        return this.httpClient.get<ClientForm>(environment.apiFormUrl + 'instances/forward');
    }

    getStoresByBrand(brandName): Observable<any> {
        return this.httpClient.post<any>(environment.apiInboxUrl + 'Stores/', JSON.stringify(brandName), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    getMenyProducts(searchText: string): Observable<MenyProduct[]> {
        return this.httpClient.get<MenyProduct[]>(environment.apiFormUrl + 'meny/products', {
            params: new HttpParams().set('searchQuery', searchText),
        });
    }
}
